'use strict';

var toastMessageHelper = require('../utils/toastMessageHelper');

$(document).ready(function () {
    /**
     * Updates the registry modal heading with the current number of registry items.
     *
     * @param {string} text - Text to display in the modal heading.
    */
    function updateRegistryModalCount(text) {
        var itemsCount = $('#registryModal .modal-body .registry-item').length;
        $('#registryModal .modal-header .registry-modal-heading').text(text + ' (' + itemsCount + ')');
    }

    /**
     * Updates the add and remove registry button states for a product.
     *
     * @param {string} productId - Product ID used to identify the registry item.
     * @param {boolean} isInRegistry - Indicates whether the product is currently in the registry.
     */
    function syncRegistryButtonState(productId, isInRegistry) {
        $('.add-to-registry-btn').each(function () {
            if (String($(this).data('pid')) === String(productId)) {
                $(this).toggleClass('d-none', isInRegistry);
            }
        });

        $('.remove-to-registry-btn').each(function () {
            if (String($(this).data('pid')) === String(productId)) {
                $(this).closest('.remove-registry-wrapper').toggleClass('d-none', !isInRegistry);
            }
        });
    }

    $('body').on('click', '.registry-copy-url-btn', function () {
        var registryShowUrl = $(this).data('url');
        $.ajax({
            url: registryShowUrl,
            type: 'GET',
            contentType: 'application/json',
            success: function (response) {
                window.location.href = response.redirectUrl;
            }
        });
    });

    // On add-to-registry click
    $('body').on('click', '.add-to-registry-btn', function (event) {
        event.preventDefault();
        var $addButton = $(this);
        var productId = $addButton.data('pid');
        var addToRegistryUrl = $addButton.data('url');

        $.ajax({
            url: addToRegistryUrl,
            method: 'POST',
            data: { pid: productId, qty: 1 },
            success: function (response) {
                if (response.success) {
                    syncRegistryButtonState(productId, true);
                    toastMessageHelper.showNotification($('#toast-add-registry-message').val());
                    $('.show-all-registry-btn').text(response.msg);
                }
            }
        });
    });

    // On remove-from-registry click
    $('body').on('click', '.remove-to-registry-btn, .wr-minicart-close-icon', function (event) {
        event.preventDefault();
        var $removeButton = $(this);
        var productId = $removeButton.data('pid');
        var removeFromRegistryUrl = $removeButton.data('url');
        var text = $removeButton.data('text');

        $.ajax({
            url: removeFromRegistryUrl,
            method: 'POST',
            data: { pid: productId },
            success: function (response) {
                if (response.success) {
                    syncRegistryButtonState(productId, false);

                    var $registryItem = $removeButton.closest('.registry-item');
                    if ($registryItem.length) {
                        $registryItem.remove();
                        updateRegistryModalCount(text);
                    }

                    $('.modal-registry-title').text(response.modalTitle);
                    $('.registry-modal-message').html(response.modalMessage);
                    $('.show-all-registry-btn').text(response.registryCountMsg);
                    toastMessageHelper.showNotification($('#toast-remove-registry-message').val());
                } else {
                    $('.modal-registry-title').text('Error');
                    $('.registry-modal-message').html(response.msg);
                }
            }
        });
    });

    $('body').on('click', '.show-all-registry-btn', function () {
        var registryItemsUrl = $('.show-registry-items').val();
        var text = $(this).data('text');
        $.ajax({
            url: registryItemsUrl,
            method: 'GET',
            success: function (html) {
                $('#registryModal .modal-body').html(html);
                updateRegistryModalCount(text);
                $('#registryModal').modal('show');
            }
        });
    });

    $('body').on('click', '.close-modal', function () {
        $('.registry-modal').remove();
    });

    $('body').on('click', '.save-registry-modal-btn', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        if (!url) { return; }
        if ($('.wedding-registry-minicart-item').length < 1) {
            toastMessageHelper.showNotification('Add Products to registry before proceeding to save registry');
            return;
        }
        $.ajax({
            url: url,
            type: 'POST'
        }).always(function () {
            $('#exit-registry-confirm-modal').modal('hide');
            $('#ready-to-share-modal').modal('show');
        });
    });

    // Reload the page once after the ReadyToShare modal is closed
    $('#ready-to-share-modal').one('hidden.bs.modal', function () {
        window.location.reload();
    });

    $('body').on('click', '.exit-registry-modal-btn', function () {
        var $btn = $(this);
        var clearUrl = $btn.data('url');
        $.ajax({
            url: clearUrl,
            method: 'POST',
            success: function (response) {
                if (response.success) {
                    $('#registryModal').modal('hide');
                    window.location.reload();
                }
            }
        });
    });
});

$(document).ready(function () {
    $('.share-wedding-registry-url').on('click', function () {
        var shareUrl = $('.registry-share-url').val();
        navigator.clipboard.writeText(shareUrl);
        $(this).blur();
        toastMessageHelper.showNotification($('#toast-success-message').val());
    });
});
